import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
} from "@mui/material";
import IconComponent from "app/shared-components/IconComponent";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import CustomerForm from "./CustomerForm";
import jwtDecode from "jwt-decode";
import { isIAMOnlyUser } from "../utilities/iamTerritoryUtils";
import { useMediaQuery, useTheme } from '@mui/material';

const CustomerList = () => {
     const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const gridRef = useRef();
  const [open, setOpen] = useState(false);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [territoryCompanies, setTerritoryCompanies] = useState([]);
  //  const token = localStorage.getItem('token');
    const token =
       localStorage &&
       localStorage.getItem("token") &&
       jwtDecode(localStorage.getItem("token"));
  const isIAMOnly = isIAMOnlyUser();
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [columnDefs, setColumnDefs] = useState([
    { field: "id", enableRowGroup: false, headerName: "Partner Number", minWidth:100},
    { field: "customerType", headerName: "Partner Type" , minWidth:100},
    { field: "name", enableRowGroup: true, headerName: "Partner Name" , minWidth:100},
    { field: "shortKey", headerName: "Short Key" , minWidth:50},
    { field: "territory", enableRowGroup: true , minWidth:50},
    { field: "countryName", enableRowGroup: true, headerName: "Country" , minWidth:50},
    { field: "emailId", enableRowGroup: true, headerName: "Email" , minWidth:100},
    // { field: 'region', enableRowGroup: true },
    { field: "active", enableRowGroup: true, cellRenderer: IconComponent , minWidth:50},
    {
      field: "hubspotSupported",
      enableRowGroup: true,
      cellRenderer: IconComponent,
      minWidth:50
    },
  ]);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Partners.xlsx",
      sheetName: "Partners",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handlePurge = (e) => {
    selectedRows.map(async (row) => {
      try {
        await OAuthService.deleteData(url, row?.id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
        loadData();
      } catch (error) {
        if (row?.customerType === "NOLTEFZE") {
          setError(
            'Deletion of Partner with Partner Type "NOLTEFZE" is not allowed'
          );
        } else {
          setError(error?.response?.data?.errorMessage || error.message);
        }
      }
    });
  };

const onGridReady = (params) => {
  setGridApi(params.api);
};

const loadData = async (territoryCompanies) => {
  gridApi?.showLoadingOverlay();
  try {
    const list = await OAuthService.getList(
      url + `?sort=name,asc&size=1000`
    );
    const companies = list.data?._embedded?.companies || [];

    if (token.scope.includes("ROLE_IAM") && !(token?.scope?.includes("ROLE_ADMIN")||token?.scope?.includes("ROLE_SOPDIR")) && territoryCompanies?.length) {
      const filteredCompanies = companies.filter(company =>
        territoryCompanies.some(
          territoryCompany => Number(territoryCompany.id) === company.id
        )
      );
      setRowData(filteredCompanies);
    } else  {
      setRowData(companies);
    }
  } catch (error) {
    setError(error.message);
  }finally {
    gridApi?.hideOverlay();
  }
};

const partners = async () => {
  try {
    const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${token.email}`;
    const areaManager = await OAuthService.getList(findAllByAreaManagerUrl);
   const areaManagerIds = areaManager?.data?._embedded?.territories?.map(t => t.id) || [];
   const queryParams = areaManagerIds.map(id => `territories=${id}`).join('&')

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryIn?${queryParams}`;
    const partners = await OAuthService.getList(url);

    const result = partners?.data?._embedded?.companies.map((value) => ({
      label: `${value?._links.company.href.split("/").pop()} ${value.name}`,
      value: value.name,
      id: value?._links.company.href.split("/").pop(),
    })) || [];

    setTerritoryCompanies(result);
  } catch (error) {
    setError(error.message);
  }
};

useEffect(() => {
  if (token.scope.includes("ROLE_IAM")&& !(token?.scope?.includes("ROLE_ADMIN")||token?.scope?.includes("ROLE_SOPDIR"))) {
    partners();
  }
}, []);

useEffect(() => {
  if (gridApi) {
    if (token.scope.includes("ROLE_IAM") && !(token?.scope?.includes("ROLE_ADMIN")||token?.scope?.includes("ROLE_SOPDIR"))) {
      if (territoryCompanies.length) {
        loadData(territoryCompanies);
      }
    } else {
      loadData();
    }
  }
}, [gridApi, territoryCompanies]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

 
const goToRoleEdit = useCallback(
  (data) => {
    if (data?.id !== undefined) {
      navigate("/editPartner/" + data.id);
    }
  },
  [navigate],
);
  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToRoleEdit(params?.data);
  };
  const onStartEditingRow = useCallback((index) => {
    gridRef.current.api.setFocusedCell(index, "name");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "name",
    });
  }, []);

  const onCellValueChanged = useCallback((event) => {
    console.log("Data after change is", event.data);
  }, []);

  const getContextMenuItems = useCallback((params) => {
    var result = [
      {
        // custom item
        name: "Edit Row",
        action: () => {
          onStartEditingRow(params.node.rowIndex);
        },
      },
      "copy",
    ];
    return result;
  }, []);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);

  return (
    <>
      <ListPageHeader
        componentName="Customer"
        onBtExport={onBtExport}
        handlePurge={isIAMOnly ? undefined : handlePurge}
        addPageLink={isIAMOnly ? undefined : "/addPartner"}
        pageName="Partner List"
        error={error}
        successMsg={successMsg}
        deleteDisable={deleteDisable}
        snackState={snackState}
        gridRef={gridRef}
      />
      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          onRowClicked={onRowClicked}
          gridRef={gridRef}
          onCellValueChanged={onCellValueChanged}
          getContextMenuItems={getContextMenuItems}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"customersList"}
        />
      </div>
      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        onClose={handleClose}
        open={open}
        // {...other}
      >
        <DialogTitle>Update Partner</DialogTitle>
        <DialogContent dividers>
          <CustomerForm
            id={selectedRows[0]?._links?.company?.href.split("/").pop()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomerList;
